module.exports = __webpack_public_path__ + "static/media/phone.f15c9b36.svg";